<template>
    <ModalTheme :overlay="false" @close="cancel" :loading="loading || parentLoading">
        <template slot="main">
            <h1 class="txtCenter" style="font-size: xx-large;">{{ "Create version" }}</h1>

            <form @submit.prevent="validateForm('form-1');" data-vv-scope="form-1">
                <table cellpadding="4px">
                    <tr>
                        <td><label for="name">Nom</label></td>
                        <td>
                            <input
                                id="name"
                                v-validate="'required'"
                                type="text"
                                name="name"
                                v-model="name"
                                class="textfield"
                                :class="{ 'textfield-error': hasError('form-1.name') }"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><label for="version">Version</label></td>
                        <td>
                            <input
                                id="version"
                                v-validate="upcoming ? '' : 'required'"
                                type="text"
                                name="version"
                                v-model="version"
                                class="textfield"
                                :class="{ 'textfield-error': hasError('form-1.version') }"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><label for="date">Date</label></td>
                        <td>
                            <input
                                id="date"
                                v-validate="upcoming ? '' : 'required'"
                                type="date"
                                v-model="dateTmp"
                                name="date"
                                class="textfield"
                                :class="{ 'textfield-error': hasError('form-1.date') }"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <label for="message">Message</label>
                            <div class="content-message"><textarea id="message" class="textfield" rows="10" v-model="description"></textarea></div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <input
                                type="checkbox"
                                v-checked="upcoming"
                                id="upcoming"
                                v-model="upcoming"
                                name="upcoming"
                                @change="changeUpcoming"
                            /><label for="upcoming">{{ $t("versioning.upcoming") }}</label>
                        </td>
                    </tr>
                </table>

                <div class="txtRight">
                    <button class="btn btn-dark" @click.stop.prevent.self="cancel">Annuler</button>
                    <button class="btn btn-dark" type="submit">Enregistrer</button>
                </div>
            </form>

            <!-- <div class="columns is-multiline"> -->
            <!-- <form @submit.prevent="validateForm('form-1')" class="columns column is-multiline is-12"> -->

            <!--
                <input name="email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('form-1.email') }" type="text" placeholder="Email">
            -->

            <!--
                <input name="password" v-validate="'required|min:6'" :class="{'input': true, 'is-danger': errors.has('form-1.password') }" type="password" placeholder="Password">
            -->
            <!-- <button class="button is-primary" type="submit" name="button">Sign up</button> -->
            <!-- <button class="button is-danger" type="button" name="button" @click="errors.clear('form-1')">Clear</button> -->
            <!-- </form> -->

            <!-- </div> -->
        </template>
        <template slot="footer"> </template>
    </ModalTheme>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalTheme from "@/components/ui/ModalTheme";

export default {
    data() {
        return {
            id: null,
            name: null,
            version: null,
            versioningDate: null,
            dateTmp: null,
            description: null,
            upcoming: false
        };
    },
    created() {
        // console.log(this.getVersioning)
        // console.log(this.$data)
        let versioning = this.getVersioning;
        if (versioning) {
            Object.keys(versioning).forEach(key => {
                // console.log(this.$data, this.$data[key], versioning[key], key)
                if (key === "versioningDate") {
                    this.dateTmp = versioning[key];
                } else {
                    this.$data[key] = versioning[key];
                }
            });
        }
    },
    mounted() {},
    components: {
        ModalTheme
    },
    computed: {
        ...mapGetters("versioning", {
            getVersioning: "getVersioning"
        })
    },
    methods: {
        ...mapActions("versioning", {
            setEdit: "setEdit",
            saveVersioning: "saveVersioning"
        }),
        changeUpcoming() {
            if (this.upcoming) {
                this.version = null;
                this.dateTmp = null;
                this.versioningDate = null;
            }
        },
        hasError(name) {
            return this.$validator.errors.has(name);
        },
        cancel() {
            this.setEdit(false);
        },
        validateForm(scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    // this.$data.date = this.$data.dateTmp
                    let date = this.$data.dateTmp === null ? null : new Date(this.$data.dateTmp).toISOString().split("T")[0];

                    let obj = this.assign(this.$data);
                    obj.versioningDate = date;
                    delete obj.dateTmp;

                    this.saveVersioning(obj).then(() => {
                        this.setEdit(false, true);
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// Versioning.vue?01dbce48